import { RouterProvider } from "react-router-dom";
import { router } from "./router";

/**
 * Root application component.
 *
 * Renders the React Router provider with all configured routes.
 * Providers (QueryClient, Auth, Tenant) are mounted in main.tsx above
 * this component so they are available throughout the entire tree.
 */
export function App() {
  return <RouterProvider router={router} />;
}
